<template>
    <div class="Address">
        <PageTitle>{{ $t('personal-account.address.title') }}</PageTitle>
        <h3>{{ $t('personal-account.address.description') }}</h3>
        <router-link
            :to="{name: 'personalAccountManualAddress'}"
            class="Address-link"
        >
            {{ $t('personal-account.address.cantFindAddress') }}
        </router-link>
        <div>
            <AddressSpot
                v-model="address"
                data-cy="input.spot-address"
                :label="$t('personal-account.address.input.label')"
                :country="$country"
                :language="$language"
                @addressSelected="fillAddress"
            />
        </div>
    </div>
</template>

<script>
import AddressSpot from '@/components/AddressSpot.vue';
import PageTitle from '@/components/PageTitle.vue';
import * as actionTypes from '@/store/action-types';
import * as mutationTypes from "@/store/mutation-types";

import Vue from "vue";
import Component from "vue-class-component";

@Component({
    components: {
        PageTitle,
        AddressSpot
    },
})
export default class Address extends Vue {
    data() {
        return {
            address: '',
        }
    }
    get currentValue() {
        return {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    }

    fillAddress(address) {
        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
        this.$store.dispatch(actionTypes.UPDATE_USER_ADDRESS, {
            data: address,
            callback: ({data}) => {
                this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
                this.$store.commit(mutationTypes.UPDATE_PROFILE, {
                    key: 'address.value',
                    value: data.address?.formatted?.join(' ') || ''
                });
                if(data){
                    this.$router.push({name: 'personalAccount'})
                } else {
                    //@TODO handle error
                }
            }
        })
    }
}

</script>
<style lang="scss" scoped>
.Address{
    width: 100%;

    h3, &-link{
        font-family: $font-lato;
        font-style: normal;
        font-weight: 400;
        font-size: 22px;
        line-height: 26px;
        color: #FFFFFF;
        mix-blend-mode: normal;
        opacity: 0.7;
    }

    &-link {
        font-size: 14px;
        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
